import Header from '../../components/admin/header/Header';
import SearchKeyword from '../../components/admin/common/SearchKeyword';
import Content from '../../components/admin/faq/Content';
import React, { useState, useEffect } from 'react';

export default function Faq() {
  const [searchParams, setSearchParams] = useState({});

  const handleSearch = (searchData) => {
    console.log('Faq 검색:', searchData);
    setSearchParams(searchData);
  };

  return (
    <>
      <Header />
      <div className="content-wrapper">
        <div className="titleNav">Faq</div>
        
        <div className="">
          <SearchKeyword
            placeholder="Faq 제목을 입력하세요"
            searchType="title"
            onSearch={handleSearch}
          />
          
          <Content searchParams={searchParams} />
        </div>
      </div>
    </>
  );
}